import { render } from "./CustomerReviewSection.vue?vue&type=template&id=0ba6bcd2&scoped=true"
import script from "./CustomerReviewSection.vue?vue&type=script&lang=js"
export * from "./CustomerReviewSection.vue?vue&type=script&lang=js"

import "./CustomerReviewSection.vue?vue&type=style&index=0&id=0ba6bcd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba6bcd2"]])

export default __exports__